import React from "react";
import "./PrivacyPolicyContent.css";

import ratelogo from "../../assets/logo.png";
const PrivacyPolicyContent = () => {
  return (
    <div className="privacyBg ">
      <div className="container privacyContent">
        <h2 className="h2">
          Privacy Policy{" "}
          <span className="smalltext"> last Modified: April 27, 2023</span>{" "}
        </h2>
        <p className="p1">
          "RATE HR" is a web based or mobile based application and is intended
          for use as is .
        </p>
        <p className="p1">
          This page is used to inform website visitors regarding our policies
          with the collection, use, and disclosure of Personal Information if
          anyone decided to use our Service.
        </p>
        <p className="p1">
          If you choose to use our Service, then you agree to the collection and
          use of information in relation to this policy. The Personal
          Information that we collect will be retained by us and used as
          described in this privacy policy.
        </p>
        <p className="p1">
          The terms used in this Privacy Policy have the same meanings as in our
          Terms and Conditions, which is accessible at "RATE HR" unless
          otherwise defined in this Privacy Policy.
        </p>
        <p className="p1">
          In case when a user wants to close accounts or delete their personal
          data then the user needs to request an email to rate@gmail.com. We
          will then review the user account and delete it accordingly.
        </p>
        <h2 className="h2">Information We Collect</h2>
        <div className="p1">
          When you use the application, we will collect the following
          information:
        </div>

        <div className="p1">
          1. Personal Information: We will collect personal information such as
          name, email address, profile picture, phone number, designation,
          gender, nationality, nic number and passport number.
        </div>
        <div className="p1">
          2. Office Information: We will collect office information such as
          name, type and address.
        </div>
        <div className="p1">
          3. Attendance Data: We will collect information about the attendance
          of your employees, including punch-in and punch-out times, location ,
          office start and end time and duration.
        </div>

        <div className="p1">
          4. Other Data: We will collect location data to allow your employer to
          see your foreground location during working hour
          {/* and information about other
          applications usage stats in the background. */}
        </div>

        <div className="p1">
          5. Device Information: We will collect app usage stats in the
          background to allow your employer to see your social media app usage
          during working hours even when the app is closed or not in use.
          {/* information about the devices you use to access the App, including
          device name, device type and operating system. Use of Information */}
        </div>
        <div className="p1">
          6. Background Location: We will collect location data in the
          background to enable employers to see your live location during
          working hours even when the app is closed or not in use.
        </div>
        <h2 className="h2" style={{ marginTop: "15px" }}>
          Use of Information
        </h2>
        <div className="p1">
          We may use the information we collect for the following purposes:
        </div>
        <div className="p1">
          1. To provide and improve our services, including to monitor
          attendance and generate reports.
        </div>
        <div className="p1">
          2. To communicate with you about our services, including to send you
          updates and information about the application.
        </div>
        <div className="p1">3. To respond to your inquiries and requests.</div>
        <div className="p1">
          4. To comply with applicable laws and regulations.
        </div>
        <h2 className="h2" style={{ marginTop: "15px" }}>
          Sharing of Information
        </h2>
        <div className="p1">
          We may share the information we collect with the following parties:
        </div>

        <div className="p1">
          1. Service Providers: We will not share information with third-party
          service providers. who help us provide and improve the application.
        </div>
        <div className="p1">
          2. Legal Purposes: We will not disclose information in response to a
          subpoena, court order, or other governmental request.
        </div>
        <div className="p1">
          3. Business Transactions: We may disclose information in connection
          with a merger, acquisition, or sale of all or a portion of our assets.
        </div>
        <h2 className="h2" style={{ marginTop: "15px" }}>
          Data Security
        </h2>
        <div className="p1">
          We take reasonable measures to protect the information we collect from
          unauthorised access, disclosure, alteration, or destruction.
        </div>
        <h2 className="h2" style={{ marginTop: "15px" }}>
          Your Choices
        </h2>
        <div className="p1">
          You may choose not to provide certain information, but this may limit
          your ability to use the App. You may also disable location services on
          your device, but this may affect the accuracy of attendance tracking.
        </div>
        <h2 className="h2" style={{ marginTop: "15px" }}>
          Updates to this Policy
        </h2>
        <div className="p1">
          We may update this Privacy Policy from time to time. If we make
          significant changes, we will provide notice through the App or by
          other means.
        </div>
        <h2 className="h2" style={{ marginTop: "15px" }}>
          Contact Us
        </h2>
        <div className="p1">
          If you have any questions or concerns about this Privacy Policy,
          please contact us at
          <b> rateeehr@gmail.com</b>
        </div>
        <div className="line" style={{ marginTop: "60px" }}></div>
      </div>

      {/* <img src={bg} className="privacy-bg" alt="" /> */}
      <img src={ratelogo} className="rate-logo" alt="" />
    </div>
  );
};

export default PrivacyPolicyContent;
